import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {AbstractReelsView} from '@gongxigames/framework/slot/modules/reels/AbstractReelsView';
import {ReelConstants} from '@gongxigames/framework/slot/utils';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {CancelStartSpinReason} from '@gongxigames/framework/slot/events';
import {Pay} from 'com/gongxigames/math/core/game/Pay';
import {SpinButtonEvents} from '@gongxigames/framework/slot/modules/spinbutton';
import {AutoplayEvents} from '@gongxigames/framework/slot/modules/autoplay';
import {FreeSpinsModule} from '@gongxigames/framework/slot/modules/freespins';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';
import {WinPresentationEvents} from '@gongxigames/framework/slot/modules/winpresentation';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {BuyBonusPopUpEvents} from '@gongxigames/framework/slot/modules/buyBonus';
import {ReelsModule} from '@gongxigames/framework/slot/modules/reels/ReelsModule';

export class ReelsBasicState extends ModuleState<AbstractReelsView, ReelsModule> {

    protected setupEvents(): void {
        this.setEventHandler(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinStartedByButton.bind(this));
        this.setEventHandler(AutoplayEvents.AUTOPLAY_START_SPIN, this.onAutoplaySpinStarted.bind(this));
        this.setEventHandler('General.BuyFeature.BUY', this.onBuyFeatureSpinStarted.bind(this));
        this.setEventHandler(FreeSpinsModule.FREESPIN_START_SPIN, this.onFreespinStartSpin.bind(this));
        this.setEventHandler(FlowModuleEvents.RESPIN_WIN, this.onRespinWon.bind(this));

        // TODO make Act, that will emit WinPresentationEvents.INITIAL_ANIMATION_STARTED,
        this.setEventHandler(WinPresentationEvents.INITIAL_ANIMATION_STARTED, this.onInitialAnimationStarted.bind(this));

        // TODO make Act, that will emit WinPresentationEvents.PAY_ANIMATION_STARTED,
        this.setEventHandler(WinPresentationEvents.PAY_ANIMATION_STARTED, this.onPayAnimationStarted.bind(this));

        // TODO make Act, that will emit WinPresentationEvents.PAY_ANIMATION_STARTED,
        this.setEventHandler(FlowModuleEvents.FREESPINS_RESTORED, this.updateReelSet.bind(this));

        // TODO make Act, that will emit WinPresentationEvents.PAY_ANIMATION_STARTED,
        this.setEventHandler(GenericPopupEvents.INTRO_STARTED, this.onPopupStarted.bind(this));

        // TODO make Act, that will emit WinPresentationEvents.PAY_ANIMATION_STARTED,
        this.setEventHandler(GenericPopupEvents.FADE_OUT_STARTED, this.onPopupFadeOutStarted.bind(this));

        // TODO make Act, that will emit WinPresentationEvents.PAY_ANIMATION_STARTED,
        this.setEventHandler(FlowModuleEvents.RESPIN_RESTORED, this.onRespinRestored.bind(this));

        // TODO - for some old games
        this.setEventHandler(BuyBonusPopUpEvents.BUY_BUTTON_CLICKED, this.onBuyButtonClicked.bind(this));
    }

    protected onBuyButtonClicked(): void {
        this.view.showAllSymbols();

        this.module.isRestoreAfterFS = false;
    }

    protected onRespinRestored(): void {
    }

    protected onPopupStarted(type: symbol): void {
    }

    protected onPopupFadeOutStarted(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_INTRO) {
            this.updateReelSet();
        }
    }

    public onEnterState(): void {
        this.view.reOrder();
    }

    public onLeaveState(): void {
    }

    protected updateReelSet(reelConstants?: typeof ReelConstants): void {
        this.view.setupReelStrip(this.module.logic.getNextReelSet().getReels(), reelConstants);
    }

    protected onSpinStartedByButton(): void {
        if (!this.module.canSpinBySpinButton) {
            return;
        }

        if (this.module.logic.nextAction !== Action.SPIN || this.module.logic.canSpin(this.module.logic.getTotalBet())) {
            this.updateReelStripWithPositions();
            this.module.gotoState(ReelsModule.SPINNING_STATE);
        } else {
            this.emit('General.Flow.cancelStartSpin', {
                reason: CancelStartSpinReason.INSUFFICIENT_FUNDS,
                balanceRefreshCallback: this.onSpinStartedByButton.bind(this),
            });
        }
    }

    protected updateReelStripWithPositions(): void {
        if (this.module.logic.spinData) {
            this.view.setupReelStripWithPositions(this.module.logic.getNextReelSet().getReels(), this.module.logic.spinData.reelPositions);
        } else {
            this.view.setupReelStrip(this.module.logic.getNextReelSet().getReels());
        }
    }

    protected onAutoplaySpinStarted(): void {
        this.updateReelStripWithPositions();
        this.module.gotoState(ReelsModule.SPINNING_STATE);
    }

    protected onBuyFeatureSpinStarted(): void {
        this.updateReelStripWithPositions();
        this.module.gotoState(ReelsModule.SPINNING_STATE);
    }

    protected onFreespinStartSpin(): void {
        this.updateReelStripWithPositions();
        this.module.gotoState(ReelsModule.SPINNING_STATE);
    }

    protected onRespinWon(): void {
        this.updateReelStripWithPositions();
        this.module.gotoState(ReelsModule.SPINNING_STATE);
    }

    protected onInitialAnimationStarted(pays: Pay[]): void {
        this.view.hidePays(pays);
    }

    /**
     * show all symbols and hide symbols on pay line
     * @param {Pay} pay
     */
    protected onPayAnimationStarted(pay: Pay): void {
        this.view.showAllSymbols();

        this.hideSymbolsOnPay(pay);
    }

    protected hideSymbolsOnPay(pay: Pay): void {
        for (const pos of pay.positions) {
            this.view.hideSymbol({x: pos.reel, y: pos.row});
        }
    }
}
